import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  ru: {
    "取消": 'Отмена',
    "确定": 'Подтвердить',
    "发送": 'Отправить',
    "系统通知": 'Системное уведомление',
    "关闭": 'Закрыть',
    "图片": 'Изображение',
    "文件": 'Файл',
    "表情": 'Эмоция',
    "视频": 'Видео',
    "录制": 'Записать',
    "拍照": 'Сделать фото',
    TUIChat,
    Component,
    time,
    AIDesk,
  },
};

export default messages;
